// extracted by mini-css-extract-plugin
export default {"layout":"layout--Kkcmk","callingScreen":"callingScreen--H29ho","animation-bzdot9":"animation-bzdot9--syqQN"};